import { If, createComponent, IntrinsicProps } from '@common/util/templateHelpers';
import { useModal } from '@common/hooks/useModal';

import Delete from '@common/components/controls/Delete';
import { CSSTransition } from 'react-transition-group';
import { useRouter } from 'next/router';
import { useEffectOnce } from '@common/hooks/useEffectOnce';

interface ModalProps extends IntrinsicProps {
  name: string
}

const Modal = createComponent<ModalProps>('Modal', 
  {}, 
  function Modal ({ className, style }, props) {
    const { state, currentModal, Teleporter } = useModal();

    return (
      <>
        {
          If(Teleporter, () => (
            <Teleporter.Source key={`modal_${props.name}`} multiple>
              <CSSTransition
                in={currentModal && currentModal.name === props.name}
                timeout={state.transition.timeout}
                classNames={`${state.transition.name}`}
                unmountOnExit
              >
                <div className={className} style={style}>
                  {props.children}
                </div>
              </CSSTransition>
            </Teleporter.Source>
          ))
            .EndIf()
        }
      </>
    );
  });
export default Modal;

/* --- */

interface ModalsProps extends IntrinsicProps {
  transitionName?: string
  transitionTimeout?: number
  bgTransitionName?: string
  bgTransitionTimeout?: number
}

export const Modals = createComponent<ModalsProps>('Modals', 
  {}, 
  function Modals ({ className, style }, props) {
    const router = useRouter();
    const { Teleporter, closeModal, currentModal, setTransition } = useModal();

    useEffectOnce(() => {
      setTransition({ 
        name: props.transitionName || 'TxPopUpScaleOut400', 
        timeout: props.bgTransitionTimeout || 400
      });

      router.events.on('routeChangeStart', closeModal);
      return () => router.events.off('routeChangeStart', closeModal);
    });

    return (
      <div className={className} style={style}>
        <CSSTransition
          in={!!currentModal}
          timeout={props.bgTransitionTimeout || 400}
          classNames={`${props.bgTransitionName || 'TxFade400'}`}
          unmountOnExit
        >
          <div className='Modals__Bg' onClick={closeModal} />
        </CSSTransition>
        <div className='Modals__Content'>
          {
            If(Teleporter, () => (
              <Teleporter.Target />
            ))
              .Else(() => (
                <div />
              ))
              .EndIf()
          }
        </div>
        {
          If(currentModal && !currentModal.options?.hideCloseButton, () => (
            <Delete large onClick={closeModal} />
          ))
            .EndIf()
        }
      </div>
    );
  });

/* --- */

interface ModalCardProps extends IntrinsicProps {
  autoWidth?: boolean,
  halfHeight?: boolean
}

const modalCardClassStates = [
  'autoWidth',
  'halfHeight'
];

export const ModalCard = createComponent<ModalCardProps>('ModalCard', 
  { classStates: modalCardClassStates }, 
  function ModalCard ({ className, style, slots }) {
    const { closeModal } = useModal();

    return (
      <div className={className} style={style}>
        {
          If(slots.title, () => (
            <header className='ModalCard__Head'>
              <p className='ModalCard__Title'>{slots.title}</p>
              <Delete onClick={closeModal} />
            </header>
          ))
            .EndIf()
        }
        <section className='ModalCard__Body'>
          {slots.defaultSlot}
        </section>
        {
          If(slots.footer, () => (
            <footer className='ModalCard__Foot'>
              {slots.footer}
            </footer>
          ))
            .EndIf()
        }
      </div>
    );
  });
